exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".average-result[data-v-38f57ef2] {\n  padding: 0.5em 8% 1em;\n}\n.average-result .bars .bar[data-v-38f57ef2] {\n  height: 0.5em;\n  background-color: #ebebeb;\n  margin: 0.5em 0.25em;\n  margin-top: 1em;\n}\n.average-result .bars .bar[data-v-38f57ef2]:first-child {\n  margin-left: 0;\n}\n.average-result .bars .bar[data-v-38f57ef2]:last-child {\n  margin-right: 0;\n}\n.average-result .bars .bar.summary-average[data-v-38f57ef2] {\n  background-color: #735e73;\n}\n@media only screen and (min-width: 760px) {\n.average-result[data-v-38f57ef2] {\n    padding: 0.5em 6% 1em;\n}\n}\n", ""]);

// exports
